import styled from 'styled-components';
import { FilterMultiselectDescription } from 'src/components/filters/types';
import {
  FaceComponentContainer,
  FaceComponentFormik,
} from 'src/components/common/FaceComponent';
import { media } from 'src/styles/designs';

const FilterFacepartOptionsContainer = styled.div`
  background: linear-gradient(
    227.25deg,
    rgba(196, 196, 196, 0) 48.08%,
    rgba(235, 235, 235, 0.47) 100%
  );

  margin-left: calc(-1 * var(--left-usable-margin));
  margin-right: calc(-1 * var(--right-usable-margin));
  padding-left: 10px;
  padding-right: 0px;

  ${media.w.lessThan.desktop} {
    overflow: hidden;

    ${FaceComponentContainer} {
      margin-right: -40px;
    }
  }

  ${media.w.greaterThanOrEqual.desktop} {
    margin-left: calc(-1 * var(--left-usable-margin));
    margin-right: calc(-1 * var(--right-usable-margin));
    padding-left: var(--left-usable-margin);
    padding-right: var(--right-usable-margin);
  }
`;
export const FilterFacepartOptions = ({
  filter,
}: {
  filter: FilterMultiselectDescription;
}) => {
  return (
    <FilterFacepartOptionsContainer>
      <FaceComponentFormik small name={filter.queryField} multi />
    </FilterFacepartOptionsContainer>
  );
};
